import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

export default {
  getters,
  mutations,
  state,
  actions,
  watch: {
    // 保存设置
    // isVerticalNavMenuActive: 'saveSettings',
    // mainLayoutType: 'saveSettings',
    // navbarSearchAndPinList: 'saveSettings',
    // verticalNavMenuWidth: 'saveSettings',
    // verticalNavMenuItemsMin: 'saveSettings',
    // theme: 'saveSettings',
    // themePrimaryColor: 'saveSettings',
    // navbarType: 'saveSettings',
    // navbarColor: 'saveSettings',
    // footerType: 'saveSettings',
    // routerTransition: 'saveSettings',
    // hideScrollToTop: 'saveSettings',
    // disableThemeTour: 'saveSettings',
    // themePrimaryColor(nv, ol) {
    //   this.$rootVM.$vs.theme({primary: nv})
    // }
  }
}